import { extendVariants, HeroTabs as StyledTabs } from '@cavela/ui';

const ExtendedTab = extendVariants(StyledTabs, {
  variants: {
    color: {
      primary: {
        tab: [
          'max-w-fit px-2 font-semibold !rounded-xl px-3 py-2',
          '!px-2 h-10 pt-0 pb-4'
        ],
        cursor: 'h-[4px]'
      },
      dark: {
        tab: [
          'max-w-fit px-2 font-semibold !rounded-xl px-3 py-2 border border-gray-4'
        ],
        tabContent: ['group-data-[selected=false]:text-secondary-text'],
        cursor: ['border border-black h-[36px] top-[-1px] w-full'],
        tabWrapper: ['border border-black']
      }
    }
  },
  defaultVariants: {
    color: 'primary',
    size: 'lg',
    variant: 'underlined'
  }
});

export default ExtendedTab;
